import UserAvatar from "@/components/AvatarComponent/UserAvatar";
import Userlabel from "@/components/AvatarComponent/Userlabel";
import i18n from "@/i18n";
import BFOverlay from "@/modules/abstract-ui/general/whisper/BFOverlay";
import MQ from "@/utils/MatchQueryUtils";
import StringUtils from "@/utils/StringUtils";
import classNames from "classnames";
import { InvoicePayment } from "../../RAInterfaces";
import "./RAInvoicePaymentCheckInfo.scss";

interface RAInvoicePaymentCheckinfoProps {
  payment: InvoicePayment;
}
const RAInvoicePaymentCheckInfo = (props: RAInvoicePaymentCheckinfoProps) => {
  const past = props.payment.data.checkedHistory || [];
  const next = props.payment.data.checkedInfo?.approvalChain
    .filter((e) => props.payment.data.value.amount > e.valueBoundary)
    .map(
      (e) =>
        e.switchFilter.find((e) => MQ.check(props.payment, e.matchQuery))?.value
          ?.user || e.default?.user
    );
  return (
    <BFOverlay
      speakerFC={(close) => (
        <div className={`padding-10`}>
          {past.length > 0 && (
            <div className={`past`}>
              <div className={`__h3 padding-bottom-5`}>
                {i18n.t(
                  "ra:RAinvoicePaymentCheckInfo.checkedBy",
                  "Freigegeben von"
                )}
              </div>
              {past.map((e) => (
                <div className={`__flex __align-center padding-top-10`}>
                  <Userlabel id={e.userId} />
                  <span className={`__sub-text`}>
                    {StringUtils.formatDate(e.date)}
                  </span>
                </div>
              ))}
            </div>
          )}
          {next.length > 0 && (
            <div className={`next`}>
              <div
                className={classNames(`__h3 padding-bottom-5`, {
                  "padding-top-20": past.length > 0,
                })}
              >
                {i18n.t(
                  "ra:RAinvoicePaymentCheckInfo.needCheck",
                  "Offene Freigaben"
                )}
              </div>
              {next.map((e) => (
                <div className={`padding-top-10`}>
                  <Userlabel id={e} />
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      enterable
    >
      <div className={classNames("ra-invoice-payment-checkinfo")}>
        {past.map((e) => (
          <div className={`ra-invoice-payment-checkinfo-item checked`}>
            <UserAvatar id={e.userId} size={"sm"} />
          </div>
        ))}
        {next.map((id) => (
          <div className={`ra-invoice-payment-checkinfo-item open`}>
            <UserAvatar id={id} size={"sm"} />
          </div>
        ))}
      </div>
    </BFOverlay>
  );
};

export default RAInvoicePaymentCheckInfo;
